import { SNIPPET_CATEGORY_IDS } from './snippetCategories.ts';

/**
 * The variant of the empty state to show when there are no snippets to display.
 */
export enum EMPTY_STATE_VARIANT {
	SEARCH = 'search',
	MY_TEMPLATES = 'my-templates',
	FAVORITES = 'favorites',
}

/**
 * Returns the empty state variant to show when there are no snippets to display.
 * - When the selected category has no snippets (isCategoryEmpty): show MY_TEMPLATES, FAVORITES, or SEARCH based on category.
 * - When the category has snippets but search/filter yields none: show SEARCH.
 */
export function getEmptyStateVariant(
	isCategoryEmpty: boolean,
	selectedCategoryId: SNIPPET_CATEGORY_IDS,
): EMPTY_STATE_VARIANT {
	if (!isCategoryEmpty) {
		return EMPTY_STATE_VARIANT.SEARCH;
	}
	if (selectedCategoryId === SNIPPET_CATEGORY_IDS.MY_TEMPLATES) {
		return EMPTY_STATE_VARIANT.MY_TEMPLATES;
	}
	if (selectedCategoryId === SNIPPET_CATEGORY_IDS.FAVORITES) {
		return EMPTY_STATE_VARIANT.FAVORITES;
	}
	return EMPTY_STATE_VARIANT.SEARCH;
}
